import React from "react"

export const KeyIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.18014 22.75C6.08014 22.75 5.97014 22.74 5.88014 22.73L3.71014 22.43C2.67014 22.29 1.73014 21.36 1.57014 20.3L1.27014 18.11C1.17014 17.41 1.47014 16.5 1.97014 15.99L6.36014 11.6C5.65014 8.76 6.47014 5.76 8.56014 3.69C11.8001 0.46 17.0701 0.45 20.3201 3.69C21.8901 5.26 22.7501 7.35 22.7501 9.57C22.7501 11.79 21.8901 13.88 20.3201 15.45C18.2201 17.53 15.2301 18.35 12.4101 17.63L8.01014 22.02C7.59014 22.46 6.84014 22.75 6.18014 22.75ZM14.4301 2.76C12.6801 2.76 10.9401 3.42 9.61014 4.75C7.81014 6.54 7.16014 9.16 7.91014 11.6C7.99014 11.87 7.92014 12.15 7.72014 12.35L3.02014 17.05C2.85014 17.22 2.71014 17.66 2.74014 17.89L3.04014 20.08C3.10014 20.46 3.51014 20.89 3.89014 20.94L6.07014 21.24C6.31014 21.28 6.75014 21.14 6.92014 20.97L11.6401 16.26C11.8401 16.06 12.1301 16 12.3901 16.08C14.8001 16.84 17.4301 16.19 19.2301 14.39C20.5101 13.11 21.2201 11.39 21.2201 9.57C21.2201 7.74 20.5101 6.03 19.2301 4.75C17.9301 3.43 16.1801 2.76 14.4301 2.76Z"
        fill="#1D1D1D"
      />
      <path
        d="M9.19008 20.54C9.00008 20.54 8.81008 20.47 8.66008 20.32L6.36008 18.02C6.07008 17.73 6.07008 17.25 6.36008 16.96C6.65008 16.67 7.13008 16.67 7.42008 16.96L9.72008 19.26C10.0101 19.55 10.0101 20.03 9.72008 20.32C9.57008 20.47 9.38008 20.54 9.19008 20.54Z"
        fill="#1D1D1D"
      />
      <path
        d="M14.5 11.75C13.26 11.75 12.25 10.74 12.25 9.5C12.25 8.26 13.26 7.25 14.5 7.25C15.74 7.25 16.75 8.26 16.75 9.5C16.75 10.74 15.74 11.75 14.5 11.75ZM14.5 8.75C14.09 8.75 13.75 9.09 13.75 9.5C13.75 9.91 14.09 10.25 14.5 10.25C14.91 10.25 15.25 9.91 15.25 9.5C15.25 9.09 14.91 8.75 14.5 8.75Z"
        fill="#1D1D1D"
      />
    </svg>
  )
}
